import $ from 'jquery';

const Popup = {
    callbacks: {
        show: {},
        hide: {}
    },

    onShow(name, callback) {
        this.callbacks.show[name] = callback;
    },

    onHide(name, callback) {
        this.callbacks.hide[name] = callback;
    },

    show(name, width = 600) {
        if (this.callbacks.show[name]) {
            this.callbacks.show[name]();
        }

        $('body')
            .css('padding-right', this.getBrowserScrollbarWidth())
            .addClass('body--noscroll');

        const popup = $(`.popup[data-popup="${name}"]`);
        if (!popup.hasClass('popup--active')) {
            popup.find('.popup__content')
                .css('width', width ? `${width}px` : 600);

            popup.addClass('popup--active')
                .css('display', 'flex')
                .hide()
                .fadeIn();
        }
    },

    get(name) {
        return $(`.popup[data-popup="${name}"]`);
    },

    showWithContent(content, width = 1300) {
        const name = 'custom-content';
        $(`.popup[data-popup="${name}"]`).find('.popup__body').html(content)
            .parents('.popup')
            .find('.popup__content')
            .css('width', width);
        Popup.show(name, width);
    },

    showWithTitle(title, content, width = 600, canClose = true) {
        const popupName = 'custom-with-title';
        const popup = this.get(popupName);

        popup.find('.popup__content').css('width', width);
        popup.find('.popup__body').html(content);
        popup.find('.popup__title').html(title);

        if (!canClose) {
            popup.addClass('popup--noclose');
        } else {
            popup.removeClass('popup--noclose');
        }

        Popup.show(popupName, width);
    },

    hide(name = '') {
        if (this.callbacks.hide[name]) {
            this.callbacks.hide[name]();
        }

        const popup = this.get(name);
        if (popup.hasClass('popup--noclose')) {
            return;
        }

        $('.popup')
            .removeClass('popup--active')
            .fadeOut(() => {
                $('body')
                    .removeClass('body--noscroll')
                    .css('padding-right', 0);
            });
        Popup.pauseAllVideos();
    },

    pauseAllVideos() {
        $('iframe').each(function () {
            $(this)[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
        $('video').each(function () {
            this.pause();
        });
    },

    notify(notifyText, canClose = true) {
        const popup = this.get('notify');

        if (canClose) {
            popup.removeClass('popup--noclose');
        } else {
            popup.addClass('popup--noclose');
        }

        $('.popup[data-popup="notify"] p').html(notifyText);
        Popup.show('notify');
    },

    watch(iframe) {
        $('.popup[data-popup="watch"] iframe').remove();
        $('.popup[data-popup="watch"] .popup__content').append(iframe);
        setTimeout(() => {
            Popup.show('watch');
        }, 400);
    },

    orderDetail(html) {
        $('.popup[data-popup="order-detail"] .order-goods').remove();
        $('.popup[data-popup="order-detail"] .popup__content').append(html);
        setTimeout(() => {
            Popup.show('order-detail');
        }, 400);
    },
    /*
        получить ширину правого скроллбара в браузере,
        чтобы при блокировании скролла body не дергался
    */
    getBrowserScrollbarWidth() {
        const windowWidth = $(window).width();
        // eslint-disable-next-line
        const innerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        return innerWidth - windowWidth;
    }
};

export default Popup;
